module.exports = __webpack_public_path__ + "static/img/Sunset.d2ad164.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/Sunset.png
// module id = 2244
// module chunks = 61